import { IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppButton from "../../../../AppComponents/AppButton";
import { AppMaterialIcons } from "../../../../AppComponents/AppMaterialIcons";
import {
  AppForm,
  AppFormError,
  AppFormField,
  AppFormObserver,
  AppFormRadioField,
  AppFormSelectField,
  AppFormToggleButtonFastField,
  AppSubmitButton,
} from "../../../../AppComponents/Forms";
import {
  SettingPageMainBoxBtnBox,
  SettingPageMainBoxTitle,
  SettingPageMainBoxTopbar,
} from "../../../../Customization/CommonElements";
import { theme } from "../../../../Customization/Theme";
import { useNotification } from "../../../../Hooks/useNotification/useNotification";
import { DefaultIndiaMobileFormat } from "../../../../Models/defaultSelectOptions";
import { CoreService } from "../../../../Services/Apis/CoreApis";
import BroadcastPreview from "../../BroadcastPreview";
import { WHATSAPP_PRIMARY_COLOR } from "../../BroadcastPreview/Constants";

import { StyledContentBox, WhatsappTemplateWrap } from "./Styles";

import { LoaderComponentProps } from "../../../../AppComponents/Loader";
import { HocBackdropLoader } from "../../../../HOC/HocBackdropLoader";
import { ChatbotConsoleService } from "../../../../Services/Apis/ChatbotConsoleService";

import {
  WhatsappCreateTemplateSchema,
  whatsappTemplateButtonTypeOptions,
  whatsappTemplateHeaderToggleOptions,
} from "../Utils/Constants";

import {
  dataToTemplateFormData,
  dataToWhatsappTemplatePayload,
} from "../Utils/utils";
import RenderDynamicButton from "./components/RenderDynamicButton";
import RenderDynamicHeaderTypes from "./components/RenderDynamicHeaderTypes";
import RenderDynamicVariableMapping from "./components/RenderDynamicVariableMapping";
import WhatsappTextRichEditor from "./components/WhatsappTextRichEditor";

interface Props extends LoaderComponentProps { }

const TemplateCreate: React.FC<Props> = ({ setLoading }) => {
  const navigate = useNavigate();
  const { showAlert } = useNotification();
  let { template_id } = useParams();
  const formRef: any = useRef();
  const [renderForm, setRenderForm] = useState<boolean>(false);
  const [categoryOptions, setCategoryOptions] = useState<any>([]);
  const [languageOptions, setLanguageOptions] = useState<any>([]);
  const [templateData, setTemplateData] = useState<any>([]);
  const [disable, setDisable] = useState<boolean>(false);
  const [statusApproved, setStatusApproved] = useState<boolean>(false);

  const [localValues, setLocalValues] = useState<any>(null);
  const sendValuesToParent = (values: any): void => {
    setLocalValues(values);
  };

  const [formikProps, setFormikProps] = useState<any>(null);
  const { values, setFieldError, errors }: any = formikProps || {};
  const [userInput, setUserInput] = useState<any>({
    template_name: "",
    template_category: 0,
    template_language: 0,
    header_type: "none",
    header_value: "",
    header_text: [],
    body_value: "",
    body_text: [],
    footer_value: "",
    footer_text: [],
    buttons_type: whatsappTemplateButtonTypeOptions[0],
    cta_buttons: [
      {
        action_type: "URL",
        button_text: "Click now",
        url_type: "static",
        url: "",
        phone_number: "",
      },
    ],
    quick_buttons: [
      {
        button_text: "Click Now",
        action_type: null,
        url_type: "static",
        url: "",
        phone_number: "",
      },
    ],
    buttons_example: [],
    variables_header: [],
    variables_body: [],
    variables_footer: [],
    variables_button: [],
    mobileCountryFormat: DefaultIndiaMobileFormat,
  });

  //* HANDLE SUBMIT BTN API CALL
  const handleSubmitBtn = (values: any, SubmitProps: any) => {
    let data: any = dataToWhatsappTemplatePayload(values);
    data["status"] = "completed";
    setLoading(true);
    ChatbotConsoleService.createWhatsappTemplate(data)
      .then((res: any) => {
        showAlert("Template Created", "success");
        SubmitProps.resetForm();
        navigate("/broadcast/whatsapp/templates");
      })
      .catch((error: any) => {
        showAlert(
          error?.response?.data?.error || "Internal server error",
          "error",
        );
      })
      .finally(() => {
        SubmitProps.setSubmitting(false);
        setLoading(false);
      });
  };
  //* HANDLE DRAFT BTN API CALL
  const handleDraftBtn = (values: any) => {
    if (!formRef?.current?.values) {
      return;
    }

    let data: any = dataToWhatsappTemplatePayload(values);
    data["status"] = "draft";

    setLoading(true);
    ChatbotConsoleService.createWhatsappTemplate(data)
      .then((res: any) => {
        navigate("/broadcast/whatsapp/history");
        showAlert("Template Drafted", "success");
        navigate(-2);
      })
      .catch((error: any) => {
        showAlert(
          error?.response?.data?.error || "Internal server error",
          "error",
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  //* GETTING REQUIRED CATGEORY DATA

  const getWhatsappTemplateCategory = () => {
    CoreService.getWhatsappTemplateCategory()
      .then((res: any) => {
        setCategoryOptions(res?.data?.config_value || []);
      })
      .catch((error: any) => { })
      .finally(() => { });
  };

  //* GETTING REQUIRED LANGUAGE DATA

  const getWhatsappTemplateLanguages = () => {
    CoreService.getWhatsappTemplateLanguages()
      .then((res: any) => {
        setLanguageOptions(res?.data?.config_value || []);
      })
      .catch((error: any) => { })
      .finally(() => { });
  };

  //* GETTING REQUIRED TEMPLATE DATA
  const getTemplateById = (id: string) => {
    setLoading(true);
    ChatbotConsoleService.getWhatsappTemplateById(id)
      .then((res: any) => {
        setTemplateData(res?.data);
        const data = dataToTemplateFormData(res?.data);
        data?.then((resolvedData) => {
          setUserInput(resolvedData);
        });
        if (
          res?.data?.status === "APPROVED" ||
          res?.data?.status === "REJECTED" ||
          res?.data?.status === "PENDING"
        ) {
          setDisable(true);
          setStatusApproved(true);
          // navigate("/broadcast/whatsapp/history");
        }
      })
      .catch((error: any) => {
        showAlert(
          error?.response?.data?.error || "Internal server error",
          "error",
        );
      })
      .finally(() => {
        setLoading(false);
        setRenderForm(true);
      });
  };

  useEffect(() => {
    if (values?.buttons_type) {
      document.getElementById("add_button")?.focus();
    }
  }, [values?.buttons_type]);

  useEffect(() => {
    getWhatsappTemplateLanguages();
    getWhatsappTemplateCategory();
    // alert(template_id)
    if (template_id) {
      getTemplateById(template_id);
    } else {
      setRenderForm(true);
    }
  }, [template_id]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <WhatsappTemplateWrap style={{ height: "calc(100vh - 64px)" }}>
      {/* TOPBAR */}
      <SettingPageMainBoxTopbar
        style={{
          backgroundColor: theme.palette.default.white,
          minHeight: "60px",
          position: "fixed",
          zIndex: 1000,
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
        }}
      >
        <SettingPageMainBoxTitle style={{ width: "100%", flexWrap: "wrap" }}>
          {" "}
          <IconButton onClick={() => navigate("/broadcast/whatsapp/templates")}>
            <AppMaterialIcons
              iconName={"ArrowBackIosRounded"}
              style={{ fontSize: "0.8rem" }}
            />
          </IconButton>
          {template_id ? "View" : "Create "} Broadcast Template
        </SettingPageMainBoxTitle>
        <SettingPageMainBoxBtnBox></SettingPageMainBoxBtnBox>
      </SettingPageMainBoxTopbar>

      <StyledContentBox
        style={{
          display: "flex",
          height: "100%",
          overflow: "hidden",
          padding: "1rem 0rem 0rem 1rem",
        }}
      >
        {/* FORM BOX */}
        <div
          className="formBox"
          style={{
            backgroundColor: theme.palette.default.background,
            padding: "16px 16px 0px 16px",
            width: "64%",
          }}
        >
          {renderForm && (
            <AppForm
              initialValues={userInput}
              onSubmit={(values: any, submitProps: any) => {
                handleSubmitBtn(values, submitProps);
              }}
              validationSchema={
                !template_id ? WhatsappCreateTemplateSchema : null
              }
              innerRef={formRef}
            >
              <div className="formBoxInner">
                <div className="templateBoader">
                  <AppFormField
                    name="template_name"
                    label="Template Name"
                    placeholder="Enter template name"
                    sendValuesToParent={(values: any) =>
                      sendValuesToParent(values)
                    }
                    disabled={disable}
                    labelStyle={{ color: theme.palette.default.black }}
                    divStyle={{ marginBottom: "2rem" }}
                  />
                  <div className="catLangDiv">
                    {categoryOptions?.length > 0 && (
                      <AppFormSelectField
                        name="template_category"
                        label="Template Category"
                        Options={categoryOptions}
                        defaultText="Select a category"
                        disabled={disable}
                        labelStyle={{ color: theme.palette.default.black }}
                      />
                    )}
                    <AppFormSelectField
                      name="template_language"
                      label="Template Language"
                      Options={languageOptions}
                      defaultText="Select a language"
                      disabled={disable}
                      enableSearch={true}
                      labelStyle={{ color: theme.palette.default.black }}
                    />
                  </div>
                </div>
                <div className="templateBoader">
                  <AppFormToggleButtonFastField
                    name="header_type"
                    label="Select Header Type"
                    Options={whatsappTemplateHeaderToggleOptions}
                    disabled={disable}
                    labelStyle={{ color: theme.palette.default.black }}
                    description="Add a title or choose which type of media you'll use for this header. Your title can't include more than one variable."
                    optionalText="(optional)"
                    divStyle={{ marginBottom: "0rem" }}
                  />
                  {/* DYNAMIC HEADER */}

                  <AppFormError name="headerVariables" />
                  <RenderDynamicHeaderTypes
                    disabled={disable}
                    headerType={
                      localValues?.header_type || userInput?.header_type
                    }
                  />
                </div>
                <div className="templateBoader">
                  {/* <WhatsappEditor name="body_valuee"/> */}
                  <AppFormError name="bodyVariables" />
                  <WhatsappTextRichEditor
                    name="body_value"
                    label="Body Message"
                    placeholder="Hey {{1}} ! Is the end of the month making you feel broke but you want to pamper yourself? Well, we have an offer. Get 20% off on all our services on the {{2}} of every month. To book, visit {{3}}."
                    variablesKey="body_text"
                    charactersLimit={1024}
                    disabled={disable}
                    labelStyle={{ color: theme.palette.default.black }}
                    description="To add a custom variable, please add a variable in double curly brackets without a space. Example: {{1}}"
                    variablesButtonLimit={10}
                  />
                </div>

                <div className="templateBoader">
                  <AppFormField
                    name="footer_value"
                    label="Footer"
                    placeholder="Footer"
                    subTitle="Add a short line of text to the bottom of your message template."
                    charactersLimit={60}
                    disabled={disable}
                    labelStyle={{ color: theme.palette.default.black }}
                    optionalText="(optional)"
                  />
                </div>

                <div className="templateBoader">
                  <AppFormRadioField
                    label={"Button"}
                    name={"buttons_type"}
                    Options={whatsappTemplateButtonTypeOptions}
                    row={true}
                    disabled={disable}
                    labelStyle={{ color: theme.palette.default.black }}
                    description="Create up to 2 Buttons that let customers respond to your message or take an action."
                    optionalText="(optional)"
                  />
                  {/* DYNAMIC BUTTONS */}

                  <RenderDynamicButton
                    disabled={disable}
                    buttonType={
                      localValues?.buttons_type?.value ||
                      localValues?.buttons_type
                    }
                  />
                  {/* VARIABLES MAPPING */}

                  <RenderDynamicVariableMapping
                    boxTitle="Add Sample Data"
                    headerVariables={localValues?.header_text}
                    bodyVariables={localValues?.body_text}
                    footerVariables={localValues?.footer_text}
                    buttonVariables={localValues?.buttons_example}
                    disabled={disable}
                  />
                </div>

                <AppFormObserver setFormikProps={setFormikProps} />
              </div>
              <div className="BtnsBox">
                {statusApproved ? (
                  <AppButton variant="outline" onClick={() => navigate(-1)}>
                    Back
                  </AppButton>
                ) : (
                  <>
                    <AppButton variant="grey" onClick={() => navigate(-2)}>
                      Cancel
                    </AppButton>
                    <AppSubmitButton
                      className="btnWidth"
                      variant="submit"
                      title={
                        template_id ? "Edit Template" : "Send for approval"
                      }
                    />
                  </>
                )}
              </div>
            </AppForm>
          )}
        </div>
        {/* PREVIEW WIDGET */}

        <BroadcastPreview
          primaryColor={WHATSAPP_PRIMARY_COLOR}
          bodyValue={localValues?.body_value?.replace(
            /\*(.*?)\*/g,
            "<strong>$1</strong>",
          )}
          headerValue={localValues?.header_value}
          footerValue={localValues?.footer_value}
          headerType={localValues?.header_type || userInput?.header_type}
          buttonsType={localValues?.buttons_type}
          buttonsData={
            (localValues?.buttons_type?.value === "quick_reply" &&
              localValues?.quick_buttons) ||
            (localValues?.buttons_type?.value === "call_to_action" &&
              localValues?.cta_buttons) ||
            (userInput?.buttons_type === "quick_reply" &&
              userInput?.quick_buttons) ||
            (userInput?.buttons_type === "call_to_action" &&
              userInput?.cta_buttons) ||
            []
          }
        />
      </StyledContentBox>
    </WhatsappTemplateWrap>
  );
};

export default HocBackdropLoader(TemplateCreate);
